import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ERoutes } from "../../../../ERoutes";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { ActivitySubActivitiesPage } from "./ActivitySubActivitiesPage";
import { ActivityApi } from "../../../../api";
import { ActivityDetailsPage } from "./ActivityDetailsPage";

export interface IActivityItemPageProps {}

export const ActivityItemPage: React.FunctionComponent<IActivityItemPageProps> = (props) => {
  const api = useApiService(ActivityApi);
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id, currentLanguage.languageId), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Activities), route: ERoutes.activity },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsActivity"
        onChange={(newTabId) => history.push(`${ERoutes.activity}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.activity} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<ActivityDetailsPage activityId={+id} editMode={state === "edit"} />}
        />
        <Tab
          id="subactivities"
          title={t(ETLCodes.SubActivities)}
          panel={<ActivitySubActivitiesPage activityId={+id} />}
          disabled={+id <= 0}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
